import React from 'react'
import { HandleInvoiceStateProvider } from './Components/HandleInvoiceStateProvider'
import NewSalesInvoiceTaxPrime from './NewSalesInvoiceTaxPrime'
import { AccountDetailsProvider } from './Components/AccountDetailsProvider'

function CreateSales({ isVoucher,accountDetails }) {

  return (
    <AccountDetailsProvider accountDetails={accountDetails}>
    <HandleInvoiceStateProvider>
      <NewSalesInvoiceTaxPrime isVoucher={isVoucher}   />
    </HandleInvoiceStateProvider>
    </AccountDetailsProvider>
  )
}

export default CreateSales